var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8327 12H5.83268V10.6667H13.8327V12ZM4.49935 12H3.16602V10.6667H4.49935V12ZM13.8327 8.66667H5.83268V7.33333H13.8327V8.66667ZM4.49935 8.66667H3.16602V7.33333H4.49935V8.66667ZM13.8327 5.33333H5.84802V4H13.8327V5.33333ZM4.49935 5.33333H3.16602V4H4.49935V5.33333Z",
    fill: "#082234"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.fee1353d591039be7d46c5c903dd6f09.svg";
export { ForwardRef as ReactComponent };